import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';
import { calcGeneratorDuration } from 'framer-motion';


export const reportsSlice = createSlice({
    name: 'reports',
    initialState: {
        items: [],
        item: {},
        procesing: false,
        message: "",
        error: "",
    },
    reducers: {
        initialStateReports: (state, action) => {
            return {
                items: [],
                item: {},
                procesing: false,
                message: "",
                error: "",
            }
        },
        setReports: (state, action) => {
            return {
                items: action.payload,
                item: {},
                procesing: false,
                message: "",
                error: "",
            }
        },
        setReport: (state, action) => {
            return {
                items: [],
                item: action.payload,
                procesing: false,
                message: "",
                error: "",
            }
        },
        setProcess: (state, action) => {
            return {
                items: [],
                item: action.payload,
                procesing: true,
                message: "",
                error: "",
            }
        },
        setReportMessages: (state, action) => {
            return {
                items: [],
                item: {},
                procesing: false,
                message: action.payload,
                error: "",
            }
        },
        setReportError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                procesing: false,
                error: action.payload,
            }
        },
    }
})

export const getStudentsWithSpacesThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/reports/cupos_reservados`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setReports(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setReportError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getStudentsWithOutSpacesThunk = (data) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/reports/cupos_pendientes_de_reservar`, data)
        .then(res => {
            if (res.status === 200) {
                dispatch(setReports(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setReportError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getContractReportThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/reports/reporte_contratos`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setReports(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setReportError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getTransportReportThunk = (searchTerm) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/reports/reporte_transporte?searchTerm=${searchTerm}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setReports(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setReportError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getDocumentReportThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/reports/reporte_documentos`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setReports(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setReportError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getFormReportThunk = () => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/reports/reporte_formularios`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setReports(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setReportError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const getFormReportByFilterThunk = (form_id) => dispatch => {
    dispatch(setProcess());
    axios.get(`/reports/reporte_formularios?form_id=${form_id}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setReports(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setReportError(res.response?.data))
            }
        })
};

export const getProcesStatusReportThunk = (procesEnd) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/reports/reporte_estado/proceso_matriculacion?procesEnd=${procesEnd}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setReports(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setReportError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const {
    initialStateReports,
    setReports,
    setReport,
    setProcess,
    setReportMessages,
    setReportError,
} = reportsSlice.actions;

export default reportsSlice.reducer; calcGeneratorDuration